<template>
    <div class="equities_vip" v-for="(item, index) in processedDatas" :key="index">
        <div v-show="item.icon || item.title" class="icon_title_div">
            <div v-show="item.icon" class="icon_div" v-html="item.icon"></div>
            <div v-show="item.title" class="title_div">{{ item.title }}</div>
        </div>
        <div class="showdata_div">
            <div v-for="header in sortedShowheader" :key="header.name" class="text-container">
                {{ header.label }} : {{ item[header.name] }}
            </div>
        </div>
        <div class="caozuo_div" v-show="Operation">
            <el-button :disabled="item.Showbutton.lookup.disabled" v-show="item.Showbutton.lookup.show" type="primary"
                @click="lookup(item)">查看</el-button>
            <el-button :disabled="item.Showbutton.deletes.disabled" v-show="item.Showbutton.deletes.show" type="primary"
                @click="deletes(item)">删除</el-button>
            <el-button :disabled="item.Showbutton.process.disabled" v-show="item.Showbutton.process.show" type="primary"
                @click="process(item)">处理</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppDataDisplay',
    props: {
        Datas: {
            type: Array,
            default: () => []  // [{'icon':'', 'title':'', 'Showbutton':'101010'}]
        },
        Operation: { // 是否显示操作区按钮
            type: Boolean,
            default: false
        },
        Showheader: {
            type: Array,
            default: () => []  // [{'name':'', 'index':1, 'label':''}]
        }

    },
    data() {
        return {
            Showbutton: {
                'lookup': { 'show': true, 'disabled': false },
                'deletes': { 'show': true, 'disabled': false },
                'process': { 'show': true, 'disabled': false }
            },
            standard: {
                'lookup': { 'show': true, 'disabled': false },
                'deletes': { 'show': true, 'disabled': false },
                'process': { 'show': true, 'disabled': false }
            }

        }
    },
    watch: {
        Datas(newVal) {
            // 当 Datas 有数据且长度大于 0 时
            if (newVal && newVal.length > 0) {
                // $nextTick 确保在数据变化引起的 DOM 更新完成后执行回调
                this.$nextTick(() => {
                    this.setStyle();
                });
            }
        }
    },
    methods: {
        lookup(dict) {
            this.$emit('lookup', dict);
        },
        process(dict) {
            this.$emit('process', dict);
        },
        deletes(dict) {
            this.$emit('deletes', dict);
        },
        checkpermissions(permissions) {
            let a = permissions.split("");
            let i = 0;
            for (let item in Object.keys(this.Showbutton)) {
                if (Number(a[i]) === 0) {
                    this.Showbutton[item].show = false;
                } else {
                    this.Showbutton[item].show = true;
                }
                if (Number(a[i + 1]) === 0) {
                    this.Showbutton[item].disabled = false;
                } else {
                    this.Showbutton[item].disabled = true;
                }
                i = i + 2;
            }
        },
        clearShowButton() {
            this.Showbutton = this.standard;
        },
        setStyle() {
            if (this.processedDatas.length > 0) {
                let showdata_div = document.getElementsByClassName('showdata_div')[0];
                let width_g = showdata_div.offsetWidth / 2;
                if (width_g == 0 || width_g == "" || width_g == null) {
                    console.error('未找到元素');
                }
                let text_container = document.getElementsByClassName('text-container');
                for (let item of text_container) {
                    item.style.setProperty('--w', width_g + 'px');
                }
            }

        }
    },
    mounted() {
        this.Showbutton = this.standard;
    },
    computed: {
        // 核心逻辑：计算属性自动监听 Showheader 变化并排序
        sortedShowheader() {
            if (!this.Showheader || this.Showheader.length === 0) return [];

            // 1. 复制一份数组 (避免直接修改 props)
            // 2. 根据 index 字段进行升序排序
            return [...this.Showheader].sort((a, b) => a.index - b.index);
        },
        processedDatas() {
            return this.Datas.map(item => {
                // 创建一个新的对象，避免直接修改原始 item（浅拷贝）
                const newItem = { ...item };

                // 核心修正：把计算结果赋值回去
                // 如果 item.Showbutton 存在，就转成十进制；否则默认 0b101010 (即 42)
                if (newItem.Showbutton) {
                    // 确保它是字符串再 parse，防止报错
                    this.checkpermissions(newItem.Showbutton);
                    newItem.Showbutton = this.Showbutton;
                    this.clearShowButton();
                } else {
                    newItem.Showbutton = this.Showbutton;
                }
                return newItem;
            });
        }
    }
}
</script>

<style scoped>
.equities_vip {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    padding: 10px 15px 10px 15px;
    background-color: white;
    margin: 15px;
    height: 250px;
    position: relative;
}

.caozuo_div {
    display: flex;
    width: 100%;
    height: 40px;
    flex-direction: row;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
}

.showdata_div {
    display: grid;
    width: 100%;
    height: calc(100% - 40px);
    padding-top: 45px;
    grid-auto-flow: row dense;
    grid-template-columns: 1fr 1fr;
    justify-items: start;
    align-content: space-around;
    justify-content: space-around;
    align-items: center;
}

.icon_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding-right: 10px;
}

.title_div {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.icon_title_div {
    position: absolute;
    top: 15px;
    left: 15px;
    display: flex;
    font-size: larger;
    font-weight: 700;
    align-items: center;
    align-content: center;
    flex-direction: row;
    flex-wrap: nowrap;

}

.text-container {
    --w: 150px;
    width: var(--w);
    /* 设置容器的宽度 */
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏超出部分 */
    text-overflow: ellipsis;
    /* 使用省略号表示超出部分 */
    display: block;
    text-align: left;
}
</style>
